<template>
    <v-card>
        <v-card-title>Archive Search</v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-text-field
                        v-model="searchParams.text"
                        label="Submission text"
                        clearable
                        outlined
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
        <v-expansion-panels accordion multiple>
            <v-divider />
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                        <v-row no-gutters>
                            <v-col cols="2">
                                Filters
                            </v-col>
                            <v-col cols="10" class="text--secondary">
                                <v-fade-transition leave-absolute>
                                    <div v-if="!open">
                                        <span v-if="filtersActive">
                                            {{ filterSentence }}
                                        </span>
                                        <span v-else>
                                            No filters active
                                        </span>
                                    </div>
                                </v-fade-transition>
                            </v-col>
                        </v-row>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="'Status'"
                                :items="searchParamOptions.status"
                                item-value="value"
                                item-text="label"
                                v-model="searchParams.status"
                                clearable
                                outlined
                                chips
                                multiple
                                deletable-chips hide-details 
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="'Admin'"
                                :items="searchParamOptions.admins"
                                item-value="value"
                                item-text="label"
                                v-model="searchParams.admin"
                                clearable
                                outlined
                                chips
                                multiple
                                deletable-chips
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="'Urgency'"
                                :items="searchParamOptions.urgent"
                                item-value="value"
                                item-text="label"
                                v-model="searchParams.urgent"
                                clearable
                                outlined
                                hide-details
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="'Image'"
                                :items="searchParamOptions.image"
                                item-value="value"
                                item-text="label"
                                v-model="searchParams.image"
                                clearable
                                outlined
                                hide-details
                            />
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- SORTING -->
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                        <v-row no-gutters>
                            <v-col cols="2">
                                Sorting
                            </v-col>
                            <v-col cols="10" class="text--secondary">
                                <v-fade-transition leave-absolute>
                                    <span v-if="!open">
                                        Sorted by {{ searchParamOptions.sortParam.find(e => e.value == searchParams.sortParam).label.toLowerCase() }}, {{ searchParamOptions.order.find(e => e.value == searchParams.order).label.toLowerCase() }}
                                    </span>
                                </v-fade-transition>
                            </v-col>
                        </v-row>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="'Sort by'"
                                :items="searchParamOptions.sortParam"
                                item-value="value"
                                item-text="label"
                                v-model="searchParams.sortParam"
                                outlined
                                hide-details
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                :label="'Order by'"
                                :items="searchParamOptions.order"
                                item-value="value"
                                item-text="label"
                                v-model="searchParams.order"
                                outlined
                                hide-details
                            />
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-divider />
            <!-- if this blank panel isn't here the divider doesn't show -->
            <v-expansion-panel>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-card-actions>
            <v-spacer />
            <v-btn class="primary" @click="submitSearch">
                Search
            </v-btn>
        </v-card-actions>
    </v-card>
</template>


<script>
export default {
    name: "ArchiveFilters",

    props: {
        searchParamOptions: {
            type: Object,
            required: true,
        },
        searchParams: {
            type: Object,
            required: true,
        },
    },

    computed: {
        filtersActive() {
            return this.searchParams.status.length > 0 || this.searchParams.admin.length > 0 || [0, 1].includes(this.searchParams.image) || [0, 1].includes(this.searchParams.urgent);
        },
        filterSentence() {
            let sentence = [];
            if (this.searchParams.status.length > 0) {
                let phrase = 'with status ';
                let statuses = this.searchParams.status.map(k => this.searchParamOptions.status.find(e => e.value == k).label.toLowerCase());
                switch (statuses.length) {
                    case 1:
                        phrase += statuses[0];
                        break
                    case 2:
                        phrase += statuses.join(' or ');
                        break
                    default:
                        phrase += statuses.slice(0, -1).join(', ')+`, or ${statuses[statuses.length-1]}`;
                }
                sentence.push(phrase);
            }
            if (this.searchParams.admin.length > 0) {
                let phrase = 'last seen by ';
                let admins = this.searchParams.admin.map(k => this.searchParamOptions.admins.find(e => e.value == k).label);
                switch (admins.length) {
                    case 1:
                        phrase += admins[0];
                        break
                    case 2:
                        phrase += admins.join(' or ');
                        break
                    default:
                        phrase += admins.slice(0, -1).join(', ')+`, or ${admins[-1]}`;
                }
                sentence.push(phrase);
            }
            if ([0, 1].includes(this.searchParams.image)) {
                sentence.push(`with ${this.searchParams.image ? 'an ' : 'no '}image`);
            }
            if ([0, 1].includes(this.searchParams.urgent)) {
                sentence.push(`that are ${this.searchParams.urgent ? '' : 'not '}urgent`);
            }
            return 'Only submissions '+sentence.join(', ');
        },
    },

    methods: {
        submitSearch: function() {
            this.$emit('submitSearch');
        },
    }
};
</script>

<style scoped>
    .v-expansion-panel:before { box-shadow: none !important; } 
</style>